var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432 461 c-15 -39 -78 -120 -93 -121 -9 0 -33 11 -53 25 l-37 25 -35 -34 c-41 -39 -124 -86 -153 -86 -24 0 -37 -18 -23 -32 6 -6 21 -2 43 11 19 12 44 21 56 21 12 0 26 7 30 15 13 22 74 65 94 65 9 0 33 -11 53 -25 36 -24 56 -25 56 -3 0 12 69 108 89 124 8 6 11 16 7 22 -11 18 -26 14 -34 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 175 l0 -175 40 0 40 0 0 175 0 175 -40 0 -40 0 0 -175z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 130 l0 -130 40 0 40 0 0 130 0 130 -40 0 -40 0 0 -130z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 105 l0 -105 40 0 40 0 0 105 0 105 -40 0 -40 0 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 90 l0 -90 40 0 40 0 0 90 0 90 -40 0 -40 0 0 -90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 70 l0 -70 40 0 40 0 0 70 0 70 -40 0 -40 0 0 -70z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharts);
export default __webpack_public_path__ + "static/media/charts.e647e29e5abbe42636c7ee854a26c72d.svg";
export { ForwardRef as ReactComponent };